export enum AboDetailNature {
  ABO,
  Customer,
  Any
}
